/**
 * Formata o valor de um input monetário e atualiza o estado com o novo valor.
 *
 * A função remove caracteres não numéricos, elimina zeros à esquerda e
 * formata o valor para o padrão monetário brasileiro, adicionando pontos como
 * separadores de milhar e vírgula para os centavos.
 * Em seguida, chama a função setValue para atualizar o estado com a string formatada.
 *
 * @param {Event} event - Evento disparado pelo input.
 * @param {Function} setValue - Função para atualizar o estado do valor formatado.
 */
export function handleInputChange(event, setValue) {
    const { value, name } = event.target;

    const newValue = value
        .replace(/\D/g, "") // Remove tudo que não for número
        .replace(/^0+/, "") // Remove os zeros iniciais
        .padStart(3, "0") // Adiciona zeros à esquerda, caso necessário
        .replace(/(\d{1,})(\d{2})$/, "$1,$2") // Adiciona a vírgula decimal
        .replace(/(?=(\d{3})+(\D))\B/g, "."); // Adiciona o ponto como separador de milhares

    setValue(`R$ ${newValue}`);
}